// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3DJzZ","buttons":"RemoveExpirationActionButtons_buttons__oKQnn"};